<script>
export default {
  name: "setPerformance",
  data() {
    return {
      form: {}
    };
  }
};
</script>

<template>
  <!-- 整体表单  -->
  <el-form ref="form" :model="form" label-width="160px">
    <el-form-item
      label="个人绩效比例"
      prop="userName"
      :rules="[
        {
          required: true,
          message: '请输入个人绩效比例',
          trigger: 'blur'
        }
      ]"
    >
      <el-input-number
        v-model="form.userName"
        placeholder="请输入个人绩效比例"
      ></el-input-number>
      %
    </el-form-item>
    <el-form-item
      label="个人绩效比例范围"
      prop="userPhone"
      :rules="[{ required: true, validator: phone, trigger: 'blur' }]"
    >
      <div class="flex">
        <el-input-number
          v-model="form.userPhone"
          placeholder="请输入个人绩效比列范围"
        ></el-input-number>
        &nbsp;&nbsp;%&nbsp;至&nbsp;&nbsp;
        <el-input-number
          v-model="form.userPhone"
          placeholder="请输入个人绩效比列范围"
        ></el-input-number>
        %
      </div>
      <div style="color: var(--danger)">个人绩效可设置比例范围</div>
    </el-form-item>
    <el-form-item
      label="团队绩效比例"
      prop="userName"
      :rules="[
        {
          required: true,
          message: '请输入团队绩效比例',
          trigger: 'blur'
        }
      ]"
    >
      <el-input-number
        v-model="form.userName"
        placeholder="请输入团队绩效比例"
      ></el-input-number>
      %
    </el-form-item>
    <el-form-item
      label="团队绩效比例范围"
      prop="userPhone"
      :rules="[{ required: true, validator: phone, trigger: 'blur' }]"
    >
      <div class="flex">
        <el-input-number
          v-model="form.userPhone"
          placeholder="请输入团队绩效比列范围"
        ></el-input-number>
        &nbsp;&nbsp;%&nbsp;至&nbsp;&nbsp;
        <el-input-number
          v-model="form.userPhone"
          placeholder="请输入团队绩效比列范围"
        ></el-input-number>
        %
      </div>
      <div style="color: var(--danger)">团队绩效可设置比例范围</div>
    </el-form-item>
    <el-form-item label="开卡激励" prop="awardWay">
      <el-radio-group v-model="form.awardWay">
        <el-radio :label="0">开启</el-radio>
        <el-radio :label="1">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="奖励金额"
      prop="userName"
      :rules="[
        {
          required: true,
          message: '请输入奖励金额',
          trigger: 'blur'
        }
      ]"
    >
      <el-input-number
        v-model="form.userName"
        placeholder="请输入奖励金额"
      ></el-input-number>
      %
    </el-form-item>
    <el-form-item
      label="奖励金额范围"
      prop="userPhone"
      :rules="[{ required: true, validator: phone, trigger: 'blur' }]"
    >
      <div class="flex">
        <el-input-number
          v-model="form.userPhone"
          placeholder="请输入奖励金额范围"
        ></el-input-number>
        &nbsp;&nbsp;%&nbsp;至&nbsp;&nbsp;
        <el-input-number
          v-model="form.userPhone"
          placeholder="请输入奖励金额范围"
        ></el-input-number>
        %
      </div>
      <div style="color: var(--danger)">奖励金额可设置范围</div>
    </el-form-item>
  </el-form>
</template>

<style scoped lang="scss"></style>
